/* app/js/src/components/external-mam/external-mam-panel/external-mam-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  height: 100%;
  width: 100%;
  background-color: #eef2f6;
}
/*# sourceMappingURL=external-mam-panel.component.css.map */
